import { render, staticRenderFns } from "./Wall.vue?vue&type=template&id=6b87bb6a"
import script from "./Wall.vue?vue&type=script&lang=js"
export * from "./Wall.vue?vue&type=script&lang=js"
import style0 from "./Wall.vue?vue&type=style&index=0&id=6b87bb6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports